/**
 * url 预处理
 * @param { String } url
 */
const formatUrl = url => {
    try {
        if (!url) {
            return url;
        }

        url = url.trim();

        if (url.indexOf('http:') === 0) {
            return url.replace('http:', '');
        } else if (url.indexOf('https:') === 0) {
            return url.replace('https:', '');
        } else if (url.indexOf('/') === 0) {
            return url.indexOf('//') === 0 ? url : `/${url}`;
        } else {
            return `//${url}`;
        }
    } catch (error) {
        console.error(error);

        return url;
    }
};

export { formatUrl };
